import React from 'react';
import maplibregl from 'maplibre-gl';
import {Map, Source, Layer, ScaleControl, GeolocateControl, NavigationControl, Popup} from 'react-map-gl/maplibre';
import {getLocationsGeoJSON} from "../Api";
import LocationPopup from "./LocationPopup";

const LocationMap = (props) => {
    const [locations, setLocations] = React.useState({'features': [], type: 'FeatureCollection'});
    const [locationPopup, setLocationPopup] = React.useState(null);
    const [cursor, setCursor] = React.useState('auto');
    const {apiBackend, defaultMapCenterLon, defaultMapCenterLat, defaultMapZoom, operatorId} = props;

    React.useEffect(() => {
        getLocationsGeoJSON(apiBackend, operatorId).then(response => {
            setLocations(response);
        });
    }, []);

    const handleOnMouseEnter = React.useCallback(() => setCursor('pointer'), []);
    const handleOnMouseLeave = React.useCallback(() => setCursor('auto'), []);
    const handleOnClick = evt => {
        if (!evt.features || evt.features.length === 0) {
            return;
        }

        setLocationPopup({
            lat: evt.lngLat.lat,
            lon: evt.lngLat.lng,
            locations: evt.features.map(feature => feature.properties),
        });
    }
    const workplacesLayerStyle = {
        id: 'locations-icons',
        type: 'circle',
        source: 'locations',
        paint: {
            'circle-radius': 7,
            'circle-color': '#29DD41FF',
            "circle-stroke-width": 1,
            "circle-stroke-color": '#025501',
        },
        cursor: 'pointer',
    };
    return <>
        <Map mapLib={maplibregl}
             mapStyle="https://tiles.binary-butterfly.de/osm-bright-gl-style/style.json"
             initialViewState={{
                 longitude: parseFloat(defaultMapCenterLon),
                 latitude: parseFloat(defaultMapCenterLat),
                 zoom: parseFloat(defaultMapZoom),
                 pitch: 0,
                 bearing: 0,
             }}
             cooperativeGestures
             style={{height: 900}}
             cursor={cursor}
             interactiveLayerIds={['locations-icons']}
             onClick={handleOnClick}
             onMouseEnter={handleOnMouseEnter}
             onMouseLeave={handleOnMouseLeave}
             onZoomStart={() => setLocationPopup(null)} // because then popups often move too much
        >
            <GeolocateControl position="top-right" />
            <NavigationControl position="top-right" />
            <ScaleControl />
            <Source id="locations" type="geojson" data={locations}>
                <Layer {...workplacesLayerStyle} />
            </Source>
            {locationPopup && (
                <Popup
                    longitude={Number(locationPopup.lon)}
                    latitude={Number(locationPopup.lat)}
                    onClose={() => setLocationPopup(null)}
                    maxWidth='320px'
                >
                    <LocationPopup
                        locations={locationPopup.locations}
                    />
                </Popup>
            )}
        </Map>
    </>;
}

export default LocationMap;
